import { useNavigate } from 'react-router-dom'
import { useObraStore } from '@stores/obraStore.js'
import { useModeStore } from '@stores/modeStore.js'
import { PageShell } from '@components/layout/PageShell.js'
import { NavIcon } from '@components/layout/NavIcons.js'
import { HOME_SECTIONS, HOME_SCREENS } from '@/config/homeScreens.js'
import { useAlertasCount } from '@hooks/useAlertasCount.js'
import { markModeExplicit } from '@utils/modePreference.js'

export function HomePage() {
  const navigate = useNavigate()
  const config = useObraStore((s) => s.config)
  const setMode = useModeStore((s) => s.setMode)
  const alertas = useAlertasCount()

  const hora = new Date().getHours()
  const saudacao = hora < 12 ? 'Bom dia' : hora < 19 ? 'Boa tarde' : 'Boa noite'

  function openScreen(to: string, mode?: 'guia' | 'obra') {
    if (mode) {
      markModeExplicit()
      setMode(mode)
    }
    navigate(to)
  }

  return (
    <PageShell variant='guia-hero'>
      <header className='cf3-home-hero'>
        <p className='cf3-home-hero__saudacao'>{saudacao}</p>
        <h1 className='cf3-home-hero__nome'>{config?.nome ?? 'Minha Obra'}</h1>
        <p className='cf3-home-hero__tag'>O que você precisa agora?</p>
      </header>

      {HOME_SECTIONS.map((section) => {
        const screens = HOME_SCREENS.filter((s) => s.section === section.id)
        if (screens.length === 0) return null

        return (
          <section
            key={section.id}
            className='cf3-home-section'
            aria-labelledby={`home-${section.id}`}
          >
            <h2 id={`home-${section.id}`} className='cf3-home-section__title'>
              {section.label}
            </h2>
            <ul className='cf3-home-grid'>
              {screens.map((screen) => {
                const badge =
                  screen.showAlertBadge && alertas > 0
                    ? alertas > 9
                      ? '9+'
                      : String(alertas)
                    : null

                return (
                  <li key={screen.to}>
                    <button
                      type='button'
                      className='cf3-home-card'
                      aria-label={`${screen.label}${badge ? ` · ${badge} alertas` : ''}`}
                      onClick={() => openScreen(screen.to, screen.mode)}
                    >
                      <span className='cf3-home-card__icon' aria-hidden>
                        <NavIcon icon={screen.icon} size={20} />
                      </span>
                      <span className='cf3-home-card__body'>
                        <span className='cf3-home-card__label'>
                          {screen.label}
                          {badge && <span className='cf3-home-card__badge'>{badge}</span>}
                        </span>
                        <span className='cf3-home-card__desc'>{screen.desc}</span>
                      </span>
                    </button>
                  </li>
                )
              })}
            </ul>
          </section>
        )
      })}
    </PageShell>
  )
}
